class MbWayContact {
    constructor(el) {
        this._init(el)
    }
    _init(el) {
        this.el = el
        if(!this.el) {
            return
        }
        this.el.method = this;

        this.el.paymentID = 105
        this.elField = document.querySelector('[data-mbway-field]')
        this.elInput = document.querySelector('[data-mbway-input]')
        this.elError = document.querySelector('[data-mbway-error]')
    }
    errorHandler(error) {
        if (error) {
            this.elField.classList.add('field-is-invalid')
            // this.elError.innerText = error
        } else {
            this.elField.classList.remove('field-is-invalid')
            // this.elError.innerText = ''
        }
    }

    getSource() {
        return new Promise((resolve, reject) => {
            if(this.checkInput(this.elInput.value)) {
                this.errorHandler('')
                resolve()
            } else {
                this.errorHandler('Invalid Number')
                reject()
            }
        })
    }

    checkInput(value) {
        return value.match(/^\d{9}$/)
    }
}

export default MbWayContact